function addContentToFolder(byId = {}, data = {}) {
  const newState = { ...byId };
  if (data.folder_id) {
    newState[data.folder_id].contents.push(data);
  }
  return newState;
}

function getUcContentsMap(data) {
  return data
    .filter((uc) => uc.folder_id)
    .reduce((ucContentsMap, uc) => {
      if (ucContentsMap[uc.folder_id]) {
        ucContentsMap[uc.folder_id][uc.id] = uc;
      } else {
        ucContentsMap[uc.folder_id] = {
          [uc.id]: uc,
        };
      }
      return ucContentsMap;
    }, {});
}

function updateContentInFolder(byId = {}, data = []) {
  const newState = { ...byId };
  const ucContentsMap = getUcContentsMap(data);

  Object.entries(ucContentsMap).forEach(([folderId, contentsMap]) => {
    const folder = newState[folderId];
    const { contents } = folder;

    newState[folderId] = {
      ...folder,
      contents: contents.map((c) =>
        contentsMap[c.id] ? contentsMap[c.id] : c,
      ),
    };
  });

  return newState;
}

function updateContentGroupInFolder(byId = {}, data = []) {
  const newState = { ...byId };
  const ucContentsMap = getUcContentsMap(data);

  Object.entries(ucContentsMap).forEach(([folderId, contentsMap]) => {
    const folder = newState[folderId];
    const { content_groups } = folder;

    newState[folderId] = {
      ...folder,
      content_groups: content_groups.map((c) =>
        contentsMap[c.id] ? contentsMap[c.id] : c,
      ),
    };
  });

  return newState;
}

export {
  updateContentInFolder,
  getUcContentsMap,
  addContentToFolder,
  updateContentGroupInFolder,
};
